import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

/**
 * NOTE: Legacy guard for accidental /thankyou visits without a session.
 * Skipped when redirect is disabled, or when the page intentionally has no sessionId
 * (lang-only /thankyou/{lang} + GET /home/thankyou).
 */
export const useEmptySessionIdRedirect = (
  noRedirect: boolean,
  sessionId: string | null | undefined,
  allowEmptySessionId: boolean = false
): void => {
  const history = useHistory();

  useEffect(() => {
    if (noRedirect || allowEmptySessionId) {
      return;
    }
    if (!sessionId) {
      history.push('/');
    }
  }, [history, sessionId, noRedirect, allowEmptySessionId]);
};
